module.exports = __webpack_public_path__ + "static/media/3-square-occupied.1176138d.svg";